/**
 * Shown instead of the app when someone signs in (for example with Microsoft) but has no
 * Junior account. No token is kept, so nothing in Junior is reachable from here.
 */
export default function NoJuniorAccount({ onBackToSignIn }: { onBackToSignIn: () => void }) {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        background: 'var(--surface-secondary, #f4f6f8)',
      }}
    >
      <section
        role="alert"
        aria-labelledby="no-account-title"
        style={{
          maxWidth: 440,
          width: '100%',
          padding: '32px 28px',
          borderRadius: 'var(--radius-xl, 12px)',
          background: 'var(--surface-primary, #fff)',
          boxShadow: 'var(--shadow-xl, 0 10px 30px rgba(0,0,0,0.12))',
          textAlign: 'center',
        }}
      >
        <h1
          id="no-account-title"
          style={{ margin: '0 0 12px', fontSize: '1.25rem', color: 'var(--text-primary, #1f2937)' }}
        >
          No Junior account
        </h1>
        <p style={{ margin: '0 0 24px', color: 'var(--gray-600, #4b5563)', lineHeight: 1.5 }}>
          You signed in, but you do not have a Junior account. Please ask a Junior administrator to
          create one for you.
        </p>
        <button
          type="button"
          onClick={onBackToSignIn}
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: 8,
            background: 'var(--primary-600, #1f6f4a)',
            color: '#fff',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Back to sign in
        </button>
      </section>
    </main>
  );
}
